var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"recommendations-setting-enabled"}},[_c('NcCheckboxRadioSwitch',{attrs:{"id":"recommendationsEnabledToggle","checked":_vm.enabled},on:{"update:checked":function($event){_vm.enabled=$event}}},[_vm._v("\n\t\t"+_vm._s(_vm.t('recommendations', 'Show recommendations'))+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }